<template>
<div class="page-shell legal-page">
  <HeadNav />

  <main>
    <header class="legal-hero">
      <div class="site-container narrow">
        <p class="eyebrow">Site policy</p>
        <h1>Privacy Policy</h1>
        <p>This policy explains how gbwhata.io handles information when you visit our website or contact us.</p>
        <div class="article-meta">
          <span>Effective October 2026</span>
        </div>
      </div>
    </header>

    <div class="article-body">
      <div class="site-container narrow article-content">
        <h2>Information We Collect</h2>
        <p>
          We may collect non-personal information such as browser type, device type, referring pages, and pages visited so we can understand site usage and improve the experience. If you contact us by email, we may keep your email address and message so we can respond.
        </p>

        <h2>How We Use Information</h2>
        <ul>
          <li>To operate, maintain, and improve the website.</li>
          <li>To respond to questions, corrections, or feedback.</li>
          <li>To monitor site performance, security, and obvious misuse.</li>
          <li>To understand which guides and pages are useful to visitors.</li>
        </ul>

        <h2>Cookies and Analytics</h2>
        <p>
          We may use cookies or similar technologies for basic site functionality, traffic measurement, and analytics. You can disable or remove cookies in your browser settings, though some parts of the website may work differently if you do.
        </p>

        <h2>Third-Party Links</h2>
        <p>
          Our pages may link to third-party websites and services. We are not responsible for their content, privacy practices, downloads, or security. Review the privacy policy and terms of any third-party site before providing information.
        </p>

        <h2>Data Security</h2>
        <p>
          We take reasonable steps to protect information associated with the site, but no method of transmission or storage is completely secure. Do not send sensitive account credentials, payment details, or private messages through a general contact channel.
        </p>

        <h2>Children's Privacy</h2>
        <p>
          This website is not directed at children. We do not knowingly collect personal information from children. If you believe a child has provided personal information, contact us so we can review and remove it where appropriate.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this policy when the site or applicable requirements change. The revised version will be posted on this page with an updated effective date.
        </p>
      </div>
    </div>
  </main>
</div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Privacy',
  components: {
    HeadNav,
  },
};
</script>

<style lang="scss" scoped>
.legal-hero {
  padding: 70px 0 58px;
  background:
    linear-gradient(rgba(22, 163, 74, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(22, 163, 74, 0.05) 1px, transparent 1px),
    linear-gradient(180deg, #eef7f1 0%, #f7fbf8 100%);
  background-size: 42px 42px, 42px 42px, auto;
  border-bottom: 1px solid var(--line);
}

.legal-hero h1 {
  color: var(--ink);
}

.legal-hero p:not(.eyebrow) {
  margin-bottom: 0;
  color: var(--ink-soft);
  font-size: 18px;
}
</style>
